import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';
import { CdwButtonModule } from '@cdw-ae/common-ui-components-button';
import { Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'administration',
  imports: [
    CommonModule,
    CdwButtonModule,
    MatCardModule,
    MaterialLibraryModule,
    ReactiveFormsModule,
  ],
  templateUrl: './administration.component.html',
  styleUrl: './administration.component.scss',
})
export class AdministrationComponent implements OnInit, OnDestroy {
  readonly accessManagementArticleUrl =
    environment.urls.support.articles.accessManagement;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  public currentCard = 'access-management';

  private onDestroy$ = new Subject<void>();

  ngOnInit(): void {
    this.activatedRoute.url
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((urlSegments) => {
        switch (urlSegments[1].path) {
          case 'access-management':
            this.currentCard = 'access-management';
            break;
          // case 'team-permissions':
          //   this.currentCard = 'team-permissions';
          //   break;
          // Commented out because this component might not even make it to production and removed entirely
          case 'audit-log':
            this.currentCard = 'audit-log';
            break;
          case 'global-settings':
            this.currentCard = 'global-settings';
            break;
          default:
            this.currentCard = 'access-management';
            break;
        }
      });
  }

  ngOnDestroy(): void {
    // Cleanup handled by component destruction
  }

  cardNavigation(path: string) {
    this.router.navigate([`administration/${path}`]);
    this.currentCard = path;
  }
}
